/* =============================================
   Poppy Creek — Barrier Repair Stick Product JS
   ============================================= */

(function() {
  'use strict';

  // Thumbnail image switching
  const thumbs = document.querySelectorAll('.pc-product__thumb');
  const mainImage = document.querySelector('.pc-product__image');

  if (thumbs.length && mainImage) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        // Update main image
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.alt = thumb.dataset.imageAlt || '';

        // Update active state
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // Variant handling
  const form = document.getElementById('product-form');
  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');
  const priceEl = document.getElementById('pc-price');
  const atcBtn = form.querySelector('.pc-atc');

  // Get product JSON from Shopify
  const productJson = document.querySelector('[data-section-id]');
  if (!productJson) return;

  // Listen for option changes
  const optionInputs = form.querySelectorAll('.pc-size-input, .pc-scent-input');

  optionInputs.forEach(input => {
    input.addEventListener('change', () => {
      updateActiveStates();
      updateVariant();
    });
  });

  function updateActiveStates() {
    // Size buttons
    document.querySelectorAll('.pc-size-btn').forEach(btn => {
      const input = btn.querySelector('input');
      btn.classList.toggle('is-active', input.checked);
    });

    // Scent buttons
    document.querySelectorAll('.pc-scent-btn').forEach(btn => {
      const input = btn.querySelector('input');
      btn.classList.toggle('is-active', input.checked);
    });
  }

  function updateVariant() {
    // Build selected options
    const selectedOptions = [];
    const sizeInput = form.querySelector('.pc-size-input:checked');
    const scentInput = form.querySelector('.pc-scent-input:checked');

    if (sizeInput) selectedOptions.push(sizeInput.value);
    if (scentInput) selectedOptions.push(scentInput.value);

    // Find matching variant via URL update (let Shopify handle it)
    const params = new URLSearchParams(window.location.search);
    
    if (sizeInput) {
      params.set('Size', sizeInput.value);
    }
    if (scentInput) {
      params.set('Scent', scentInput.value);
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);

    // Reload to get new variant (simple approach)
    // For a smoother experience, you'd fetch variant JSON and update dynamically
    window.location.href = newUrl;
  }
})();